import { InfoWidget } from "./infoWidget";
import BannerWidget from "./bannerWidget";
import MultipleLargeWidgetScroll from "./multipleLargeWidget";
import MultipleSmallWidgetScroll from "./multipleSmallWidget";
import InfoPageScrollWidget from "./infoPageScrollWidget";
import GuestDetailsWidget from "./guestDetailsWidget";
import { IFrameRendererHome } from "./iFrameRendererHome";
import GuestItineraryWidget from "./guestItineraryWidget";
import MultiControllerWidget from "./multiControllerWidget";
import SmallIconMultipleWidget from "./smallIconMultipleWidget";
import BannerMultipleWidget from "./bannerMultipleWidget";
import WeatherWidget from "./weatherWidget";
import InfoMultipleWidget from "./infoMultipleWidget";


export const widgetDisplayType = [
  {
    type: 'Info Widget Type',
    CompName: InfoWidget,
  },
  {
    type: 'Banner Widget Type',
    CompName: BannerWidget,
  },
  {
    type: 'Info Scroll Widget Type',
    CompName: MultipleLargeWidgetScroll,
  },
  {
    type: 'Small Icon Scroll Widget Type',
    CompName: MultipleSmallWidgetScroll,
  },
  {
    type: "Guest Details",
    CompName: GuestDetailsWidget,
  },
  {
    type: "Guest Itinerary",
    CompName: GuestItineraryWidget,
  },
  {
    type: "URL iFrame Renderer (Open Default)",
    CompName: IFrameRendererHome
  },
  {
    type: "Multi Controller",
    CompName: MultiControllerWidget
  },
  {
    type: "Small Icon Multiple Widget Type",
    CompName: SmallIconMultipleWidget
  },
  {
    type: "Banner Multiple Widget Type",
    CompName: BannerMultipleWidget
  },
  {
    type: "Info Page Scroll Widget",
    CompName: InfoPageScrollWidget
  },
  {
    type: "Weather",
    CompName: WeatherWidget
  },
  {
    type: "Info Multiple Widget Type",
    CompName: InfoMultipleWidget
  }
];
